module.exports = __webpack_public_path__ + "static/wing-leader-0319b7061f4c07b6b184fbd1767e679c.jpg";